import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { getTodaysDate } from 'utils/LocalDateTimeHelper'

import { isLoading, get, load } from '../reducers/meetings';

import GreyhoundRacingRacecardsForDate from '../components/GreyhoundRacingRacecardsForDate';

const REFRESH_INTERVAL_MILLIS = 10000;

@standardAsyncConnect([
  {
    dispatch: ({params: {date = getTodaysDate("YYYY-MM-DD")}}) => load(date),
    preventResolve: ({state, params: {date = getTodaysDate("YYYY-MM-DD")}}) => isLoading(state, date),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => ({meetingsByDate: get(state)})
  }
])
@catchLifeCycleErrors
export default class GreyhoundRacingRacecardsForDateContainer extends Component {
  static propTypes = {
    // supplied by react-router via @connect
    params: PropTypes.shape({
      date: PropTypes.string
    }),
    meetingsByDate: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired
  };

  render() {
    return (
      <GreyhoundRacingRacecardsForDate
        date={this.props.params.date}
        dateIncrement={1}
        meetingsByDate={this.props.meetingsByDate}
        routes={this.props.routes}
        raceType="Greyhounds"/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingRacecardsForDateContainer.js